"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _hoisted_1 = { class: "text-black" };
var _hoisted_2 = {
    key: 0,
    class: "pointer-events-none absolute top-0 flex min-h-[60px] w-full items-center justify-between p-4"
};
var vue_3 = require("vue");
var vue_i18n_1 = require("vue-i18n");
var SvgIcon_vue_1 = require("@SharedVueComponents/SvgIcon/SvgIcon.vue");
var use_imageUpload_1 = require("@/composables/use-imageUpload");
var use_trackingErrors_1 = require("@/composables/use-trackingErrors");
exports.default = (0, vue_1.defineComponent)({
    __name: 'FormKitImage',
    props: {
        modelValue: {},
        label: {},
        name: {},
        validation: {}
    },
    emits: ["update:modelValue"],
    setup: function (__props, _a) {
        var emit = _a.emit;
        var props = __props;
        var t = (0, vue_i18n_1.useI18n)().t;
        var hasWrongTypeError = (0, vue_3.ref)(false);
        var wrongFileTypeErrorMessage = t("imageUploadPage.errorFileTyp", [use_imageUpload_1.acceptedFiles]);
        var handleChange = function (event) {
            hasWrongTypeError.value = !isValidFileType(event.target.value);
            hasWrongTypeError.value
                ? use_imageUpload_1.invalidTypeFieldNames.value.add(props.name)
                : use_imageUpload_1.invalidTypeFieldNames.value.delete(props.name);
            if (hasWrongTypeError.value)
                (0, use_trackingErrors_1.trackImageWrongType)(t);
        };
        var handleDelete = function () {
            hasWrongTypeError.value = false;
            theModel.value = [];
            use_imageUpload_1.invalidTypeFieldNames.value.delete(props.name);
        };
        var isValidFileType = function (fileNameParam) {
            var _a;
            var fileName = fileNameParam || ((_a = theModel.value[0]) === null || _a === void 0 ? void 0 : _a.name);
            var acceptedFileTypes = use_imageUpload_1.acceptedFiles.split(",").map(function (str) { return str.trim().replace(".", ""); });
            var fileType = fileName.split(".").pop() || "";
            if (acceptedFileTypes.includes(fileType)) {
                return true;
            }
            return false;
        };
        var theModel = (0, vue_3.computed)({
            get: function () { return props.modelValue; },
            set: function (value) { return emit("update:modelValue", value); },
        });
        return function (_ctx, _cache) {
            var _component_FormKit = (0, vue_2.resolveComponent)("FormKit");
            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_FormKit, {
                modelValue: theModel.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((theModel).value = $event); }),
                name: _ctx.name,
                type: "file",
                label: _ctx.label,
                accept: (0, vue_2.unref)(use_imageUpload_1.acceptedFiles),
                validation: _ctx.validation,
                errors: [hasWrongTypeError.value ? (0, vue_2.unref)(wrongFileTypeErrorMessage) : ''],
                onChange: handleChange
            }, {
                fileName: (0, vue_2.withCtx)(function (context) { return [
                    (context === null || context === void 0 ? void 0 : context._value[0])
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", {
                            key: 0,
                            class: (0, vue_2.normalizeClass)(["overflow-hidden text-ellipsis whitespace-nowrap", { 'border-error': (0, vue_2.unref)(use_imageUpload_1.imageUploadSizeOverLimit) || hasWrongTypeError.value }])
                        }, [
                            (0, vue_2.createElementVNode)("span", {
                                class: (0, vue_2.normalizeClass)((0, vue_2.unref)(use_imageUpload_1.imageUploadSizeOverLimit) ? 'text-error' : 'text-gray-80')
                            }, (0, vue_2.toDisplayString)((0, vue_2.unref)(use_imageUpload_1.formatFileSize)(context._value[0].file.size)) + " - ", 3),
                            (0, vue_2.createElementVNode)("span", _hoisted_1, (0, vue_2.toDisplayString)(context._value[0].name), 1)
                        ], 2))
                        : (0, vue_2.createCommentVNode)("", true),
                    (0, vue_2.createVNode)(SvgIcon_vue_1.default, {
                        "icon-name": "close",
                        class: (0, vue_2.normalizeClass)(["absolute right-4 text-black", { 'text-error': (0, vue_2.unref)(use_imageUpload_1.imageUploadSizeOverLimit) || hasWrongTypeError.value }])
                    }, null, 8, ["class"])
                ]; }),
                noFiles: (0, vue_2.withCtx)(function (context) { return [
                    (!context._value[0])
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_2, [
                            (0, vue_2.createVNode)(SvgIcon_vue_1.default, {
                                "icon-name": "upload",
                                class: "mr-2 text-xl"
                            }),
                            (0, vue_2.createVNode)(SvgIcon_vue_1.default, {
                                "icon-name": "plus-thin",
                                class: "ml-2 text-xl"
                            })
                        ]))
                        : (0, vue_2.createCommentVNode)("", true)
                ]; }),
                fileRemove: (0, vue_2.withCtx)(function () { return [
                    (0, vue_2.createElementVNode)("button", {
                        type: "button",
                        class: "formkit-file-remove absolute right-4 h-5 w-5 opacity-0",
                        onClick: handleDelete
                    }, [
                        (0, vue_2.createVNode)(SvgIcon_vue_1.default, {
                            "aria-label": "Entfernen",
                            "icon-name": "close",
                            class: (0, vue_2.normalizeClass)(["absolute right-4 text-black", { 'text-error': (0, vue_2.unref)(use_imageUpload_1.imageUploadSizeOverLimit) || hasWrongTypeError.value }])
                        }, null, 8, ["class"])
                    ])
                ]; }),
                _: 1
            }, 8, ["modelValue", "name", "label", "accept", "validation", "errors"]));
        };
    }
});
